// 配置文件保存一些共用的，代码层面上不做修改的，调用频率一般的静态数据
// 调用频率高的可放入bus中
// 需要动态修改的请使用vuex

// api请求配置
export const hcApiConfig = {
  seq: 1
}
export const crmApiConfig = {
  cid: 3,
  v: 5
}
export const slApiConfig = {
  cid: 8,
  v: 1
}
export const cloudApiConfig = {}
export const lblApiConfig = {
  seq: 1,
  version: 'V1.0'
}
export const xfyApiConfig = {}
export const lgjApiConfig = {}
export const scApiConfig = {}
export const sevApiConfig = {
  cid: 12,
  v: 1
}

export const WxAppId = 'wxc1710c833df6b777'

// 环境变量
let env = 'pro'
if (process.env.NODE_ENV === 'development') env = 'local'
else if (/10\.173\.173\.154/.test(location.host)) env = 'dev1'
else if (/10\.160\.0\.91/.test(location.host)) env = 'dev2'
else if (/sevapp\.leelen\.net/.test(location.host)) env = 'test1'
else if (/10\.173\.173\.156/.test(location.host)) env = 'test1'
else if (/10\.160\.0\.98/.test(location.host)) env = 'test2'
else if (/10\.160\.0\.136/.test(location.host)) env = 'test3'
else if (/10\.160\.2\.50/.test(location.host)) env = 'pre'

export const baseENV = env
console.log('baseENV', baseENV)

// 请求地址
const lblUrlList = {
  // 本地环境
  local: 'http://10.160.0.26',
  // 开发环境
  dev1: 'http://10.160.0.66',
  dev2: 'http://10.160.0.26',
  // 测试环境
  test1: 'https://iotst-sq.leelen.net',
  test2: 'https://iottest.leelen.net',
  test3: 'https://iottest.leelen.net',
  // 预生产环境
  pre: 'https://iotpre.leelen.net',
  // 生产环境
  pro: 'https://iot.leelen.com'
}

export const sevH5lblUrl = lblUrlList[baseENV]
console.log('sevH5lblUrl', sevH5lblUrl)
